export default __webpack_public_path__ + "static/media/be.653c8328.svg";